<template>
  <!-- Modal for software infos -->
  <el-dialog :visible.sync="show"
             :close-on-click-modal="false"
             :close-on-press-escape="false"
             :show-close="false"
             width="350px"
             top="30vh">
    <div class="confirm-container">
      <div class="confirm-tip"><span :class="type">!</span>{{ tips.title }}</div>
      <div class="confirm-content">{{ tips.info }}</div>
    </div>

    <span slot="footer"
          class="dialog-footer">
      <el-button v-if="confirm"
                 class="button-cancel"
                 @click="Hide">{{
        languages.cancel
      }}</el-button>
      <el-button v-if="!confirm"
                 class="button-confirm"
                 type="primary"
                 :loading="submitting"
                 @click="Hide">{{ languages.confirm }}
      </el-button>
      <el-button v-if="confirm"
                 class="button-confirm"
                 type="primary"
                 :loading="submitting"
                 @click="Install">{{btnType==='Confirm'?languages.confirm : languages.install }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
    languages: Object,
    type: String,
    confirm: Boolean,
    show: Boolean,
    tips: Object,
    submitting: Boolean,
    btnType: String,
  },
  methods: {
    Hide () {
      this.$parent.hideInfoDialog();
    },
    Install () {
      this.$parent.installSoftware();
    },
  },
};
</script>

<style lang="scss" scoped></style>
